import * as React from 'react';
import {CSSProperties} from 'react';
import styled from 'styled-components';
import {ClearButton} from './common/ClearButton';
import {DateSelector} from './common/DateSelector';

import {
  addMinutesToDate,
  formatDateForHuman,
  formatDateUTC,
  toDate,
} from '../dates/dates';

type Props = {
  value: any;
  placeholder?: string;
  readOnly?: boolean;
  onChange?: (dateStr: string) => void;
  style?: CSSProperties;
  hideClearButton?: boolean;
  businessDayStartTimeMinutes?: number;
};

export function DateWidget(props: Props) {
  const onSelectDate = (date?: Date | null) => {
    // When a date is selected, set the data to the business start time for that date.
    const value = formatDateUTC(
      addMinutesToDate(date, props.businessDayStartTimeMinutes),
    );

    if (props.onChange) {
      props.onChange(value);
    }
  };

  if (props.readOnly) {
    const date = toDate(props.value);
    const dateStr = formatDateForHuman(date);
    return <Container style={props.style}>{dateStr}</Container>;
  }

  const onClear = () => {
    onSelectDate();
  };

  return (
    <Container style={props.style}>
      <DateSelector
        value={toDate(props.value)}
        onSelectDate={onSelectDate}
        placeholder={props.placeholder}
      />
      {props.hideClearButton ? null : (
        <ClearButton
          onClick={onClear}
          styles={{root: {marginLeft: '0.5rem'}}}
        />
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  font-size: 1rem;
  max-width: 300px;
`;
